import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function CDAInfo() {
  return (
    <div className="-m-2.5 mt-12 overflow-auto">
      <div className="mx-6 my-2">
        <div className="font-bold text-2xl text-start">
          Create and track custom data attributes (CDAs)
        </div>
        <p className="text-sm text-gray-700 pt-1 text-start">
          Create and track custom data that matters to your business.
        </p>
        <div className="pt-5 flex items-center gap-3">
          <img
            className="w-10 h-10 border-2 border-white rounded-full"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
            alt=""
          />
          <div className="flex flex-col text-sm text-gray-700 text-start">
            <div>Written by Anish Dhakal</div>
            <div>Updated over a month ago</div>
          </div>
        </div>
        <div className="font-normal text-base mt-6">
          <button className="flex justify-between items-center w-full px-3 py-2 border rounded-lg shadow">
            <span>Table of contents</span>
            <ChevronDownIcon className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
        <p className="mt-6 text-start text-sm">
          Create and track custom data attributes (CDAs) about your users and
          leads, based on criteria that’s specific to your business. You can use
          this data to filter and create customer segments, and to send targeted
          messages and campaigns. You can also use it as qualification data to
          qualify leads and trial users
        </p>
        <div className="mt-6 font-semibold text-start">
          What’s a custom data attribute?
        </div>
        <p className="mt-4 text-start text-sm">
          A custom data attribute (CDA) tracks facts about your customers — like
          the plan someone is on, or when they signed up — as opposed to an
          event, which tracks recurring customer actions.
        </p>
        <p className="mt-4 text-start text-sm">
          <span className="font-bold">Here’s an example: </span>If your product
          is a project management tool, you could track data about the number of
          files each user has. Then, if you want to message users who haven’t
          started adding files to the tool and might need some help onboarding,
          you could set up a message targeted to users with "files less than 1".
        </p>
        <div className="mt-4 text-sm text-start">
          The most common CDAs set up on Intercom are about customer
          development, such as:
          <ul className="list-disc ml-6">
            <li>Price plan</li>
            <li>Value of purchases</li>
            <li>Number of teammates added</li>
            <li>Number of songs played</li>
            <li>Date subscription ends</li>
          </ul>
        </div>
        <div className="mt-6 border rounded-2xl bg-yellow-100 p-5 text-sm text-start">
          There’s a limit of 250 People and Company CDAs per workspace, but you
          can archive unused attributes to free up space.
        </div>
      </div>
    </div>
  );
}

export default CDAInfo;
